var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.project.link,"target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":_vm.project.src,"alt":"behance project"}}),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.project.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }